<template>
    <v-app>
        <v-app-bar
        app
        color="primary"
        dark
        >
            <div class="d-flex align-center">
                <v-img
                alt="Vuetify Logo"
                class="shrink mr-2"
                contain
                src="./assets/logo.jpg"
                transition="scale-transition"
                width="90"
                height="50"
                />
            </div>

            <v-spacer></v-spacer>

            <v-btn
                href=""
                target="_blank"
                text
            >
                <span class="mr-2">Erreape</span>
                <v-icon>mdi-microphone</v-icon>
            </v-btn>
        </v-app-bar>

        <v-main>
            <v-container>
                <router-view/>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>

export default {
    name: 'App',

    data: () => ({
        //
    }),
};
</script>
